import { render, staticRenderFns } from "./SideBuilding.vue?vue&type=template&id=47f22e50&"
import script from "./SideBuilding.vue?vue&type=script&lang=js&"
export * from "./SideBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports